// 图标 FontClass/Symbol 前缀，如果在iconfont上定义的前缀为hzero-icon-，值取hzero-icon
export var HZERO_ORIGIN_ICON_NAME = 'hzero-icon';